function Loader() {
  return (
    <div className="loader" style={{position:"fixed", width:"100%", height:"100%",backgroundColor:"#000000cc", color:"#ffffff"}}>

      <div className="text-center align-middle">Loading...</div>
    </div>
  )
}
export default Loader